import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import EdtDynamicCheckTable from './table/EdtDynamicCheckTable';
import EdtDynamicCheckEditForm from './editform/EdtDynamicCheckEditForm';

i18next.addResourceBundle('en', 'edtDynamicCheck', en);
i18next.addResourceBundle('hu', 'edtDynamicCheck', hu);

export default [
	{
		path: '/edt-dynamic-check/edit/:id/:tabKey?',
		component: EdtDynamicCheckEditForm,
		auth: authRoles.edtDynamicCheck
	},
	{
		path: '/edt-dynamic-check/:sessionNameParam?',
		component: EdtDynamicCheckTable,
		auth: authRoles.edtDynamicCheck
	}
];
